import { isEmpty, isNil } from 'ramda';
import { culturalSpecialistOptions } from '@bridebook/toolbox/src/supplier/constants';
import { getSupplier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import extraSections from '@bridebook/web/app-shared/components/supplier/sections/features/render-sections';

const useFeatures = () => {
  const supplier = useSelector(getSupplier);
  const supplierType = supplier?.type?.[0];

  if (!supplier || !supplierType) return false;

  const typeDetails = supplier?.typeDetails?.[supplierType];

  if (!typeDetails) return false;

  const { renderSections } = extraSections[supplierType];

  const sections: (keyof typeof typeDetails | 'tags')[] = renderSections
    .filter((section): section is keyof typeof typeDetails => section in typeDetails)
    .sort();

  const culturalExperienceTags = supplier?.tags?.filter(
    (tag) => tag !== culturalSpecialistOptions.notApplicable,
  );

  if (
    supplierType === 'venue' &&
    !isNil(culturalExperienceTags) &&
    !isEmpty(culturalExperienceTags)
  ) {
    sections.push('tags');
  }

  if (sections.length === 0) return false;

  return {
    typeDetails,
    sections,
    culturalExperienceTags,
  };
};

export { useFeatures };
